<template>
  <figure class="flex flex-col items-center gap-2">
    <div
      v-if="svgMarkup"
      class="rounded bg-white p-1.5 leading-none"
      role="img"
      aria-label="QR code"
      v-html="svgMarkup"
    />
    <figcaption
      v-if="caption"
      class="qr-caption"
    >
      {{ caption }}
    </figcaption>
  </figure>
</template>

<script setup lang="ts">
import { RSS_G1_QR_CAPTION } from '@lucimark/shared/helpers/rssFeedDisplay'
import QRCode from 'qrcode'
import { ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    url: string
    caption?: string
  }>(),
  { caption: RSS_G1_QR_CAPTION }
)

const svgMarkup = ref('')

watch(
  () => props.url,
  async (url) => {
    if (!url.trim()) {
      svgMarkup.value = ''
      return
    }
    try {
      svgMarkup.value = await QRCode.toString(url, {
        type: 'svg',
        margin: 1,
        width: 256,
        errorCorrectionLevel: 'M',
        color: { dark: '#000000', light: '#ffffff' }
      })
    }
    catch {
      svgMarkup.value = ''
    }
  },
  { immediate: true }
)
</script>

<style scoped>
.qr-caption {
  margin: 0;
  max-width: var(--g1-qr-caption-max-width, 28ch);
  text-align: center;
  font-size: var(--g1-qr-caption-size, clamp(12px, 1vw, 16px));
  font-weight: 600;
  line-height: 1.35;
  color: var(--g1-text-muted, rgb(255 255 255 / 0.8));
}

:deep(svg) {
  display: block;
  width: var(--g1-qr-size, clamp(104px, min(13vw, 22vh), 180px));
  height: var(--g1-qr-size, clamp(104px, min(13vw, 22vh), 180px));
}
</style>
